import { useEffect, useState } from 'react';
import { getSubscriptionOffersAPI } from 'src/api';
import { useCurrentUser } from 'src/hooks';
import type { Offer, Store } from 'src/types';

export const useGetSubscriptionOffers = (
  store: string,
  cartValue: number,
  hasPrimeDeal = false,
): Offer[] => {
  const { user } = useCurrentUser();
  const [offers, setOffers] = useState<Offer[]>([]);

  useEffect(() => {
    const isSacPlus = user
      ? user.subscription && user.subscription.tier !== 'free'
      : false;

    getSubscriptionOffersAPI(store as Store, { isSacPlus, cartValue, hasPrimeDeal })
      .then(setOffers)
      .catch(() => {
        setOffers([]);
      });
  }, [store, cartValue, hasPrimeDeal, user]);

  return offers;
};
